import { useEffect, useState } from "react";
import "./pinUnlock.css";
import BackspaceIcon from "@mui/icons-material/Backspace";
const PinUnlock = ({ setTimeUnlockCurrent }) => {
  const arrayPin = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  const pin = "1234";
  const [currentPin, setCurrentPin] = useState("");

  const handleChoosePin = (number) => {
    if (currentPin.length >= 4) return;

    setCurrentPin(currentPin + number);
  };

  const resetCurrentPin = () => {
    setCurrentPin("");
  };

  const handleDeletePin = () => {
    resetCurrentPin();
  };

  const handleOK = () => {
    if (currentPin.length < 4) return;
    if (pin !== currentPin) {
      const currentPinDots = document.querySelectorAll(".current-pin-dot");
      currentPinDots.forEach((element) => {
        element.classList.add("animated");
      });
      setTimeout(resetCurrentPin, 1000);
    } else setTimeUnlockCurrent(true);
  };

  const handleKeyPress = (e) => {
    // enter
    if (e.keyCode === 13) handleOK();
    // brojevi i brojevi na Num pad-u
    else if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    )
      handleChoosePin(parseInt(e.key));
  };

  const handleClick = () => {
    const wrapperPinUnlock = document.querySelector(".wrapper-pin-unlock");
    wrapperPinUnlock.focus();
  };

  useEffect(() => {
    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div className="unlock-screen">
      <div
        className="wrapper-pin-unlock"
        tabIndex={0}
        onKeyDown={handleKeyPress}
      >
        <div className="current-pin">
          {currentPin.split("").map((_, index) => {
            return <div className="current-pin-dot" key={index}></div>;
          })}
        </div>
        <div className="wrapper-pin-choose-element">
          {arrayPin.map((number, index) => {
            return (
              <div
                className="number-choose-pin"
                key={index}
                onClick={() => handleChoosePin(number)}
              >
                {" "}
                {number}
              </div>
            );
          })}
        </div>
        <div className="pin-delete-dot" onClick={handleDeletePin}>
          <BackspaceIcon style={{ height: "100%", width: "100%" }} />
        </div>
        <div className="pin-ok-dot" onClick={handleOK}>
          OK
        </div>
      </div>
    </div>
  );
};

export default PinUnlock;
